import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import html2pdf from 'html2pdf.js';

const OfferLetter = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const printRef = useRef();

  const superAdminId = Number(localStorage.getItem('adminuserId')) || 0;

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        documentTitle: 'Joining_Letter',
     });

  const handleDownloadPDF = () => {
  const element = printRef.current;

  const opt = {
    margin: [5, 5, 5, 5],          // Perfect padding so content doesn't cut
    filename: "Offer_Letter.pdf",
    image: { type: "jpeg", quality: 0.98 },

    html2canvas: {
      scale: 3,                   // HD rendering (fixes blurry text)
      useCORS: true,              // allows cross-origin images
      allowTaint: true,           // helps load local images
      logging: false,
      dpi: 300,
      letterRendering: true,
    },

    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait",
      compressPdf: true,
    },
  };

   html2pdf().set(opt).from(element).save();
  };


  useEffect(() => {
    if (!state?.user) {
      alert("No user data provided");
      navigate('/');
    }

    const fetchCompany = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
        );
        const data = await response.json();

        if (response.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, '')}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error('Error fetching company details:', err);
      } finally {
        setLoading(false);
      }
    };

    if (superAdminId) fetchCompany();
  }, [navigate, state?.user, superAdminId]);

  const user = state?.user;
  if (!user) return null;
  if (loading) return <p>Loading company details...</p>;

  return (
    <div className="letter-wrapper">
      {/* Letter Content */}
      <div className="joining-letter" ref={printRef}>

        {/* Header */}
        <div className="letter-header">
          <img 
            src={company?.logoUrl || '/default-logo.png'} 
            alt="Company Logo" 
            className="letter-logo" 
          />
          <div className="letter-company-info"  style={{ textAlign: 'center' }}>
            <h2>{company?.name}</h2>
            <p><strong>Regt. Office:</strong> {company?.address}</p>
            <p><strong>CIN:</strong> {company?.cin}</p>
            <p><strong>Email:</strong> {company?.email}</p>
            <p><strong>Contact:</strong> {company?.contact || 'N/A'}</p>
          </div>

          <img
            style={{ opacity: 0 }}
            src={company?.logoUrl || "/default-logo.png"}
            alt="Company Logo"
            className="letter-logo"
          />

        </div>

        {/* Body */}
        <div className="letter-body">
          <p style={{ textAlign: 'center', fontSize: '26px', fontWeight: 'bold' }}>
            <strong>Offer of Employment</strong>
          </p>

          <p style={{ textAlign: 'right' }}>
            <strong>Date:</strong> {new Date().toLocaleDateString()}
          </p>

          <p>To,</p>
          <p><strong>{user.fullName}</strong></p>
          <p><strong>{user.address}</strong></p>
          <p><strong>{user.district}, {user.state}, {user.pincode}</strong></p>

          <p><strong>Subject:</strong> Offer of Employment</p>

          <p><strong>Dear {user.fullName.split(" ")[0]},</strong></p>

          <p>
            We are pleased to offer you the position of <strong>{user.roleName}</strong> at 
            <strong> {company?.name}</strong>. We were impressed with your background and skills,
            and we are confident that you will be a valuable addition to our team.
          </p>

          <hr />

          {/* 1. Position Details */}
          <p><strong>1. Position Details:</strong></p>
          <p>• <strong>Job Title:</strong> {user.roleName}</p>
          <p>• <strong>Department:</strong> {user.branch}</p>
          <p>• <strong>Reporting To:</strong> ______________________</p>
          <p>• <strong>Start Date:</strong> {new Date().toLocaleDateString()}</p>
          <p>• <strong>Location:</strong> {user.bankBranch}</p>

          <hr />

          {/* 2. Compensation */}
          <p><strong>2. Compensation:</strong></p>
          <p>• <strong>Salary:</strong> ₹____________ per month</p>
          <p>• <strong>Payment Frequency:</strong> Monthly</p>
          <p>• <strong>Other Benefits:</strong> ______________________</p>

          <hr />

          {/* 3. Terms */}
          <p><strong>3. Terms and Conditions:</strong></p>
          <p>• This offer is subject to verification of your documents and background checks.</p>
          <p>• You must sign a confidentiality and non-disclosure agreement upon joining.</p>
          <p>• Further terms will be detailed in your official employment agreement.</p>

          <hr />

          <p>Please confirm your acceptance of this offer by signing and returning a copy of this letter by _____________.</p>

          <p>We look forward to welcoming you to <strong>{company?.name}</strong> and wish you success in your new role.</p>

          {/* Signature */}
          <div className='no-break'>
              <p><strong>Warm regards,</strong></p>
              <p><strong>{company?.name}</strong></p>
              <p><strong>{company?.email}</strong></p>
              <p><strong>{company?.address}</strong></p>

              <hr />

              {/* Acceptance Section */}
              <p><strong>Accepted and Agreed by:</strong></p>
              <p>Name: {user.fullName}</p>
              <p>Signature: _______________________</p>
              <p>Date: _______________________</p>
          </div>

        </div>

          {/* Footer */}
          <div className="letter-footer">
            <hr />
            <p>{company?.name} | CIN: {company?.cin}</p>
            <p>Email: {company?.email} | Address: {company?.address}</p>
          </div>
      
      </div>


        {/* PDF / Print Buttons */}
        <div className="letter-actions">
          <button onClick={handlePrint} className="letter-action-button">Print</button>
          <button onClick={handleDownloadPDF} className="letter-action-button">Download</button>
        </div>
    </div>
  );
};

export default OfferLetter;
